export default __webpack_public_path__ + "static/media/landing.fede1ff0.jpeg";